"use client";

import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
const FONT_STYLE = `
    .hero-grain::after {
        content: '';
        position: absolute;
        inset: 0;
        background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='0.05'/%3E%3C/svg%3E");
        pointer-events: none;
        z-index: 10;
    }
`;
const AboutHero = () => {
  const $ = _c(18);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <style>{FONT_STYLE}</style>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      scale: 1.1,
      opacity: 0
    };
    t2 = {
      scale: 1,
      opacity: 0.4
    };
    t3 = {
      duration: 2,
      ease: "easeOut"
    };
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <motion.div initial={t1} animate={t2} transition={t3} className="absolute inset-0 z-0"><img src="https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?q=80&w=2000&auto=format&fit=crop" alt="Historical indenture-era photograph representing Girmitiya heritage" className="w-full h-full object-cover grayscale-[30%] sepia-[15%]" /><div className="absolute inset-0 bg-gradient-to-t from-[#0F1C2E] via-[#0F1C2E]/60 to-[#0F1C2E]/20" /></motion.div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      opacity: 0,
      y: 30
    };
    t6 = {
      opacity: 1,
      y: 0
    };
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      duration: 1,
      delay: 0.2,
      ease: [0.16, 1, 0.3, 1]
    };
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-8"><div className="w-8 h-px bg-[#DF6D2A]" /><span className="font-body text-[11px] tracking-[0.25em] uppercase text-[#DF6D2A]">Our Identity</span></div>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <motion.div initial={t5} animate={t6} transition={t7} className="w-full lg:w-[65%]">{t8}<h1 className="font-display text-[38px] sm:text-[56px] md:text-[80px] lg:text-[96px] xl:text-[110px] font-light leading-[0.95] text-[#F4EFE6] tracking-tight">Preserving <br /><em className="text-[#C9A84C] italic">History</em></h1></motion.div>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  let t11;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      opacity: 0,
      x: 20
    };
    t11 = {
      opacity: 1,
      x: 0
    };
    $[10] = t10;
    $[11] = t11;
  } else {
    t10 = $[10];
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      duration: 1,
      delay: 0.4,
      ease: [0.16, 1, 0.3, 1]
    };
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="max-w-[1280px] mx-auto w-full px-4 sm:px-6 md:px-8 relative z-20"><div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 sm:gap-8 lg:gap-12">{t9}<motion.div initial={t10} animate={t11} transition={t12} className="w-full lg:w-[35%] lg:pb-4 border-l border-white/20 pl-4 sm:pl-6 md:pl-10"><p className="font-body text-[14px] sm:text-[16px] md:text-[18px] font-light text-white/70 leading-[1.7] sm:leading-[1.8]">The Global Girmitiya Council is the premier international body dedicated to the archival, educational, and cultural preservation of the Indian indenture diaspora.</p></motion.div></div></div>;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  let t15;
  let t16;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      opacity: 0
    };
    t15 = {
      opacity: 0.08
    };
    t16 = {
      duration: 2,
      delay: 0.5
    };
    $[14] = t14;
    $[15] = t15;
    $[16] = t16;
  } else {
    t14 = $[14];
    t15 = $[15];
    t16 = $[16];
  }
  let t17;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <>{t0}<section className="relative min-h-[420px] h-[60svh] md:h-[100svh] max-h-[700px] bg-[#0F1C2E] overflow-hidden flex flex-col justify-end pb-12 sm:pb-16 md:pb-24 hero-grain">{t4}{t13}<motion.div initial={t14} animate={t15} transition={t16} className="absolute top-1/4 right-0 pointer-events-none select-none z-10"><span className="font-display text-[27vw] leading-none text-[#F4EFE6] whitespace-nowrap">EST. 2024</span></motion.div></section></>;
    $[17] = t17;
  } else {
    t17 = $[17];
  }
  return t17;
};
export default AboutHero;